import { useDispatch } from "react-redux";
import { RatesDespatch } from "./RatesStore";

export const useRatesDispatch = useDispatch.withTypes<RatesDespatch>();
